import { render, staticRenderFns } from "./ReportClosure.vue?vue&type=template&id=85f1f6e0&"
import script from "./ReportClosure.vue?vue&type=script&lang=js&"
export * from "./ReportClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports